import script from "./img-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./img-upload.vue?vue&type=script&setup=true&lang=js"

import "./img-upload.vue?vue&type=style&index=0&id=c00b7e80&lang=scss"

const __exports__ = script;

export default __exports__